// extracted by mini-css-extract-plugin
export var avatarContainer = "_59-1";
export var largeAvatarContainer = "_59-2";
export var smallAvatarContainer = "_59-0";